import TrackerList from './list/TrackerList'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import TrackerDetail from './detail/TrackerDetail'
import { isProduction } from 'utils'

export const MAX_TRACKER_SIZE = isProduction ? 100 : 20

const Tracker = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={`${path}/:trackId(\\d+)`}>
        <TrackerDetail />
      </Route>
      <Route exact path={`${path}`}>
        <TrackerList />
      </Route>
    </Switch>
  )
}

export default Tracker
